/**
 * SHA-256 of a Blob's bytes, as lowercase hex.
 *
 * Used for Media Library content-deduplication. Safe to hash the whole file in
 * one shot because uploads are capped at 30 MB (digest runs in ~50-150 ms with
 * trivial memory). If that cap is ever raised for large video, switch to a
 * size-tiered sampled fingerprint (see the design doc "Future work").
 */
export const sha256Hex = async (blob: Blob): Promise<string> => {
  const buffer = await blob.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buffer);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
